// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file base/v1/interval.proto (package base.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message base.v1.Interval
 */
export const Interval = /*@__PURE__*/ proto3.makeMessageType(
  "base.v1.Interval",
  () => [
    { no: 1, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "microseconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

